import type { AppStore } from "@/store/AppStore";
import type { GetNoteInput, GetNoteOutput } from "@mem-client/ai-toolkit/contract";
import {
  AiToolkitToolName,
  getNoteInputSchema,
  getNoteOutputSchema,
} from "@mem-client/ai-toolkit/contract";
import type { AiToolkitToolDefinition } from "@/modules/ai-toolkit/tools/types";
import {
  assertNoteIsAvailable,
  buildLocalNote,
  DEFAULT_CONTENT_CHAR_LIMIT,
} from "@/modules/ai-toolkit/tools/notes/note-tools.helpers";

export const getNote = async ({
  store,
  input,
}: {
  store: AppStore;
  input: GetNoteInput;
}): Promise<GetNoteOutput> => {
  const note = assertNoteIsAvailable({
    note: await store.notes.getAsync(input.noteId),
    noteId: input.noteId,
  });

  return {
    note: await buildLocalNote({
      store,
      note,
      includeContent: input.includeContent ?? "none",
      maxContentChars: input.maxContentChars ?? DEFAULT_CONTENT_CHAR_LIMIT,
      missingContentBehavior: "throw",
    }),
  };
};

export const getNoteTool: AiToolkitToolDefinition<
  AiToolkitToolName.GetNote,
  GetNoteInput,
  GetNoteOutput
> = {
  name: AiToolkitToolName.GetNote,
  inputSchema: getNoteInputSchema,
  outputSchema: getNoteOutputSchema,
  strict: true,
  execute: getNote,
};
